module.exports = __webpack_public_path__ + "static/lyft-0158575aac7ec4692cb8814e9c238686.jpg";